import { SubSpec } from './sub-spec.model';

export class Spec {
  _id?: string;
  name: string = '';
  value: string = ''; 
  subSpecs: Array<SubSpec> = []; 
  position: number = 0;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/spec.model.ts